import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route, Navigate } from "react-router-dom";
import { TooltipProvider } from "../../ui/tooltip";
import "../../assets/css/RiskExplorer/style.css";

// @ts-ignore
import Header from "../../components/Header";
// @ts-ignore
import RightAside from "../../components/RightAside";
// @ts-ignore
import UserService from "../../services/UserService";

import { HealthPage } from "./pages/HealthPage";
import { InputStabilityPage } from "./pages/InputStabilityPage";
import { ObservabilityPage } from "./pages/ObservabilityPage";

const queryClient = new QueryClient();

function RiskExplorerInner() {
  useEffect(() => {
    document.body.classList.add("risk-explorer-active");
    return () => document.body.classList.remove("risk-explorer-active");
  }, []);

  const token = UserService.getToken();

  return (
    <div className="risk-explorer-theme">
      <Header
        token={token}
        isMarketplacePage={false}
        notificationsCount={0}
        refreshNotifications={() => {}}
        setIndustry={() => {}}
        setCompany={() => {}}
        leftNode={null}
        productLabel="Model Drift Monitoring"
        fixed={true}
      />
      <Routes>
        <Route index element={<HealthPage />} />
        <Route path="input-stability" element={<InputStabilityPage />} />
        <Route path="observability" element={<ObservabilityPage />} />
        <Route path="*" element={<Navigate to="/model-drift-monitoring" replace />} />
      </Routes>
      <RightAside showChildrenWhenNoPanel={false}>{null}</RightAside>
    </div>
  );
}

export default function RiskExplorer() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <RiskExplorerInner />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
